import type { LocationQuery } from 'vue-router';
import type { VariantDto } from '~/models/ListingProduct.api.model';
import { QUERY_COLOR, QUERY_COND, QUERY_STORAGE } from './queryParamHelpers';

export type ParamsToPacIdMap = {
  [key: string]: {
    colorName: string;
    storageSize: string;
    condition: string;
    pacId: number;
  };
};

export const createParamsToPacIdMap = (variants: VariantDto[] = []) => {
  const newMap: ParamsToPacIdMap = {};

  variants.forEach((variant) => {
    const value = {
      colorName: variant.Color.ColorName,
      storageSize: variant.StorageSize,
      condition: variant.Condition,
      pacId: variant.ProductAttributeCombinationId,
    };

    const color = pdp_toQueryParamValue(variant.Color.ColorName);
    const storage = pdp_toQueryParamValue(variant.StorageSize);
    const condition = pdp_toQueryParamValue(variant.Condition);

    const onlyColorKey = `${QUERY_COLOR}=${color}`;
    const onlyStorageKey = `${QUERY_STORAGE}=${storage}`;
    const onlyConditionKey = `${QUERY_COND}=${condition}`;

    const colorAndStorageKey = `${QUERY_COLOR}=${color},${QUERY_STORAGE}=${storage}`;
    const colorAndConditionKey = `${QUERY_COLOR}=${color},${QUERY_COND}=${condition}`;
    const storageAndConditionKey = `${QUERY_STORAGE}=${storage},${QUERY_COND}=${condition}`;

    const colorStorageConditionKey = `${QUERY_COLOR}=${color},${QUERY_STORAGE}=${storage},${QUERY_COND}=${condition}`;

    if (!newMap[onlyColorKey]) {
      newMap[onlyColorKey] = value;
    }
    if (!newMap[onlyStorageKey]) {
      newMap[onlyStorageKey] = value;
    }
    if (!newMap[onlyConditionKey]) {
      newMap[onlyConditionKey] = value;
    }

    if (!newMap[colorAndStorageKey]) {
      newMap[colorAndStorageKey] = value;
    }
    if (!newMap[colorAndConditionKey]) {
      newMap[colorAndConditionKey] = value;
    }
    if (!newMap[storageAndConditionKey]) {
      newMap[storageAndConditionKey] = value;
    }

    if (!newMap[colorStorageConditionKey]) {
      newMap[colorStorageConditionKey] = value;
    }
  });

  return newMap;
};

export const createParamMapKeyFromParams = (query?: LocationQuery) => {
  if (!query) {
    return '';
  }

  let paramKeyString = '';

  const color = query.color;
  const storage = query.storage;
  const cond = query.cond;

  // So that the order is kept consistent and non-existing params aren't in the string
  if (color) {
    paramKeyString += `${QUERY_COLOR}=${color}`;
  }
  if (storage) {
    paramKeyString += `,${QUERY_STORAGE}=${storage}`;
  }
  if (cond) {
    paramKeyString += `,${QUERY_COND}=${cond}`;
  }

  return paramKeyString;
};
